import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Nav, NavItem, Button, Tab } from 'react-bootstrap';
import _, { forEach as _forEach } from 'lodash';
import FormInput from 'components/forms/FormInput';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { confirmAlert } from 'react-confirm-alert';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import { cartAddEdition } from 'actions/CartActions';
import { campaignSettingsEditR, campaignSettingsNewR, setVariablesAboutListR } from 'actions/ListActions';
import { duplicateCampaignAndEditionsR } from 'actions/CampaignActions';
import may from 'js/security';
import { ROLE_ADMIN, ROLE_WL_ADMIN } from 'js/constants';
import ClientRoles from 'components/layout/client/ClientRoles';
import Loader from 'components/layout/Loader';
import SimplePrompt from '../SimplePrompt';

class CampaignSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validation: {
        title: {
          valid: true,
          helpText: '',
          rules: 'required',
        },
        publisherInfo: {
          valid: true,
          helpText: '',
          rules: 'required',
        },
        ownerAssigned: null, // null|string username
        creatorAssigned: null, // null|string username
      },
      // ordering: false,
      markCampaign: false,
      duplicateForSingleUsers: [],
      duplicateForAllUsersOfCompany: [],
    };
  }

  componentDidUpdate = prevProps => {
    const {
      closeSettings,
      exeThen,
      setVariablesAboutListR,
      history,
      appIntl,
      linkDataR,
      showSettingsAbout,
      pendingArchive,
    } = this.props;

    if (exeThen === 'startRenewListAndCloseSettings') {
      closeSettings();
      setVariablesAboutListR('startRenewListAndCloseSettingsReset');
    }

    if (exeThen === 'startHistory') {
      history.push(appIntl.urlPrefix + 'account/campaigns/' + linkDataR);
      setVariablesAboutListR('startHistoryReset');
    }

    if (
      showSettingsAbout === 'campaignDetails' &&
      prevProps.pendingArchive !== pendingArchive &&
      pendingArchive === false
    ) {
      history.push(appIntl.urlPrefix + 'account/campaigns');
    }
  };

  storeCampaign = (id, option) => {
    const { showSettingsAbout, storeCampaignR } = this.props;
    if (showSettingsAbout !== 'campaignDetails') {
      this.closeSettings();
    }
    storeCampaignR(id, option);
  };

  saveSettings = () => {
    const {
      campaign,
      action,
      messages,
      setVariablesAboutListR,
      campaignSettingsEditR,
      campaignSettingsNewR,
    } = this.props;
    const { validation, markCampaign, ownerAssigned, creatorAssigned } = this.state;
    let isValid = true;
    if (!this.title.state.value?.length) {
      validation.title.helpText = messages.campaign.campaign_title_valid;
      validation.title.valid = false;
      isValid = false;
    }
    if (this.publisher.state.value === '' || typeof this.publisher.state.value === 'undefined') {
      validation.publisherInfo.helpText = messages.campaign.campaign_publisher_valid;
      validation.publisherInfo.valid = false;
      isValid = false;
    }

    if (!isValid) {
      setVariablesAboutListR('campaignsavingfalse');
      this.setState({
        validation,
      });
      return;
    }
    setVariablesAboutListR('campaignsavingtrue');

    if (action === 'edit') {
      campaign.title = this.title.state.value;
      campaign.publisherInfo = this.publisher.state.value;
      campaign.marked = markCampaign;
      const campaignParam = _.cloneDeep(campaign);
      campaignParam.editions = null;

      if (ownerAssigned) {
        campaignParam.owner = { username: ownerAssigned };
      }

      if (creatorAssigned) {
        campaignParam.creator = { username: creatorAssigned };
      }

      const params = JSON.stringify(campaignParam);
      campaignSettingsEditR(campaign, params);
    } else if (action === 'new') {
      const params = {
        title: this.title.state.value,
        publisherInfo: this.publisher.state.value,
        marked: markCampaign,
      };
      campaignSettingsNewR(params);
    }
  };

  closeSettings = () => {
    const { closeSettings } = this.props;
    closeSettings();
  };

  setInactive = () => {};

  addToCart = () => {
    // this.setState({ ordering: true });
    const { campaign, addToCart } = this.props;
    for (let i = 0; i < campaign.editions.length; i++) {
      addToCart(campaign.editions[i]);
    }
    const showInterval = window.setInterval(() => {
      const { isCampaignInCart, messages } = this.props;
      if (isCampaignInCart() === true) {
        window.clearInterval(showInterval);
        // this.setState({ ordering: false });

        const options = {
          customUI: ({ onClose }) => {
            return (
              <div className="react-confirm-alert-body">
                <h1>{messages.cart.title}</h1>
                <p>{messages.campaign.added_to_cart}</p>
                <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
                  <Button
                    style={{ margin: '0 auto', marginTop: '20px', width: '100px' }}
                    bsStyle="primary"
                    onClick={onClose}
                  >
                    OK
                  </Button>
                </div>
              </div>
            );
          },
          childrenElement: () => <div />,
          closeOnEscape: true,
          closeOnClickOutside: true,
        };

        confirmAlert(options);
      }
    }, 1000);
  };

  changedCampaign = () => {
    const { setVariablesAboutListR } = this.props;
    setVariablesAboutListR('changedtrue');
    this.setState({
      markCampaign: true,
    });
  };

  setTitleRef = element => {
    this.title = element;
  };

  setPublisherRef = element => {
    this.publisher = element;
  };

  setOwner = (name, value) => {
    const ownerAssigned = value?.username ?? null;
    this.setState({ ownerAssigned });
  };

  setCreator = (name, value) => {
    const creatorAssigned = value?.username ?? null;
    this.setState({ creatorAssigned });
  };

  copyToSingleUser = (name, value) => {
    this.setState({ duplicateForSingleUsers: value });
  };

  copyToAllUsersOfCompany = (name, value) => {
    this.setState({ duplicateForAllUsersOfCompany: value });
  };

  createDuplicates = type => {
    const { duplicateForSingleUsers, duplicateForAllUsersOfCompany } = this.state;
    const { campaign, duplicateCampaignAndEditionsR } = this.props;
    let value = [];

    if (type === 'user') {
      value = duplicateForSingleUsers;
    }
    if (type === 'company') {
      value = duplicateForAllUsersOfCompany;
    }

    const data = {
      type,
      value,
    };
    duplicateCampaignAndEditionsR(data, campaign.id);
  };

  getClientDisplayName = data => {
    const firstName = data?.profile?.first_name || '';
    const lastName = data?.profile?.last_name || '';
    return '' + (firstName || '') + (lastName || '');
  };

  isAllowedToChangeOwnerCreator = () => {
    const { user: { roles = [] } = {} } = this.props;
    const allowedRoles = [ROLE_ADMIN, ROLE_WL_ADMIN];
    return allowedRoles.some(role => may(role, roles));
  };

  isAllowedToDuplicate = () => {
    const { user } = this.props;
    let allowed = false;
    if (may('ROLE_WL_ADMIN', user.roles) || may('ROLE_ADMIN', user.roles)) {
      allowed = true;
    }
    return allowed;
  };

  render() {
    const {
      campaign,
      messages, // messages.campaign are in props!
      action,
      deleter,
      user,
      campaignSavingR,
      pendingCopyR,
      statusCopyR,
      typeOfCopyR,
    } = this.props;

    const { validation, duplicateForSingleUsers, duplicateForAllUsersOfCompany } = this.state;
    const { profile } = user;
    const defaultPublisher = [
      profile.company ? profile.company + ', ' : '',
      profile.first_name,
      profile?.last_name ? profile.last_name + ', ' : '',
      profile?.street,
      profile?.house_number ? profile.house_number + ', ' : '',
      profile?.zip_code,
      profile?.city,
    ]
      .filter(value => value !== null && value !== undefined)
      .join(' ');

    const showTransfer = this.isAllowedToChangeOwnerCreator();
    const showDuplicate = this.isAllowedToDuplicate();
    const KEY_CONFIG = 'configuration';
    const KEY_TRANSFER = 'transfer';
    const KEY_DUPLICATE = 'duplicate';

    const disableDuplicateForUsers = duplicateForSingleUsers.length === 0;
    const disableDuplicateForUsersOfCompany = duplicateForAllUsersOfCompany.length === 0;

    return (
      <div className="campaign-settings">
        <div className="left-content">
          <div className="row">
            <Tab.Container defaultActiveKey={KEY_CONFIG} id="campaignSettingTabs" onSelect={console.log}>
              <Row>
                <Nav bsStyle="pills">
                  <NavItem eventKey={KEY_CONFIG}>
                    <i className="fad fa-cog" /> {messages.campaign.configuration}
                  </NavItem>
                  {showTransfer && (
                    <NavItem eventKey={KEY_TRANSFER}>
                      <i className="fas fa-exchange-alt" /> {messages.transfer_campaign}
                    </NavItem>
                  )}
                  {showDuplicate && (
                    <NavItem eventKey={KEY_DUPLICATE}>
                      <i className="fad fa-clone" /> {messages.duplicate_campaign}
                    </NavItem>
                  )}

                  {/* <NavItem eventKey="budget"><i className="fad fa-coins"/> {messages.budget}</NavItem>
                 <NavItem eventKey="access"><i className="fad fa-share-alt"/> {messages.access}</NavItem> */}
                </Nav>
                <Tab.Content animation>
                  <Tab.Pane eventKey={KEY_CONFIG}>
                    <FormGroup>
                      <FormInput
                        type="text"
                        label={messages.campaign.title}
                        name="title"
                        meta={{
                          validate: { rules: validation.title.rules },
                          acl: { write: true },
                        }}
                        validation={validation.title}
                        value={campaign.title ? campaign.title : ''}
                        ref={this.setTitleRef}
                        onChange={this.changedCampaign}
                      />
                      <FormInput
                        type="text"
                        name="publisherInfo"
                        infoText={messages.publisher_info_text}
                        label={messages.campaign.publisher}
                        meta={{
                          validate: { rules: validation.publisherInfo.rules },
                          acl: { write: true },
                        }}
                        validation={validation.publisherInfo}
                        value={campaign.publisherInfo || campaign.publisher_info || defaultPublisher}
                        ref={this.setPublisherRef}
                        onChange={this.changedCampaign}
                      />
                      <FormSwitchery
                        name="marked"
                        label={messages.mark_campaign}
                        value
                        checked={!!campaign.marked}
                        onChange={this.changedCampaign}
                      />
                    </FormGroup>
                    {campaign.creator && (
                      <p>{messages.campaign.creator + ' ' + this.getClientDisplayName(campaign?.creator)}</p>
                    )}
                  </Tab.Pane>
                  {showTransfer && (
                    <Tab.Pane eventKey={KEY_TRANSFER}>
                      <Row>
                        <Col xs={12} md={12}>
                          <h4>{messages.campaign.transfer_title}</h4>
                        </Col>
                        <Col xs="12" md="6">
                          <h5>
                            {messages.campaign.campaign_owner}: {this.getClientDisplayName(campaign?.owner)}
                          </h5>
                          <FormAutocomplete
                            label={messages.campaign.change_owner}
                            name="user"
                            onChange={this.setOwner}
                            returnValueObject
                            autocompleteType="user"
                            urlFilters={{
                              filters: {
                                // teams: '!' + teamId,
                              },
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" md="6">
                          <h5>
                            {messages.campaign.campaign_creator}: {this.getClientDisplayName(campaign?.creator)}
                          </h5>
                          <FormAutocomplete
                            label={messages.campaign.change_creator}
                            name="user"
                            onChange={this.setCreator}
                            returnValueObject
                            autocompleteType="user"
                            urlFilters={{
                              filters: {
                                // teams: '!' + teamId,
                              },
                            }}
                          />
                        </Col>
                      </Row>
                    </Tab.Pane>
                  )}
                  {showDuplicate && (
                    <Tab.Pane eventKey={KEY_DUPLICATE}>
                      <Row>
                        <Col xs={12} md={12}>
                          <h4>{messages.duplicate_campaign_description}</h4>
                        </Col>
                        <Col xs="12" md="12">
                          <FormAutocomplete
                            label={messages.clone_to_single_user}
                            name="user"
                            onChange={this.copyToSingleUser}
                            returnValueObject
                            autocompleteType="user"
                            urlFilters={{ filters: {} }}
                            multi
                          />
                          {pendingCopyR ? (
                            <Loader />
                          ) : (
                            <div>
                              <Button
                                bsSize="large"
                                bsStyle="default"
                                onClick={() => {
                                  this.createDuplicates('user');
                                }}
                                disabled={disableDuplicateForUsers}
                              >
                                <i className="fa-fw bg-green fad fa-clone" />
                                {messages.duplicate_campaign}
                              </Button>
                              {typeOfCopyR === 'user' ? (
                                statusCopyR === 'success' ? (
                                  <>
                                    <i className="fas fa-check-circle text-success fa-2x m-l-5" />
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-exclamation-circle text-danger fa-2x m-l-5" />
                                  </>
                                )
                              ) : (
                                <></>
                              )}
                            </div>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" md="12">
                          <FormAutocomplete
                            label={messages.clone_to_all_users_of_company}
                            name="client"
                            onChange={this.copyToAllUsersOfCompany}
                            returnValueObject
                            autocompleteType="client"
                            urlFilters={{ filters: {} }}
                            multi
                          />
                          {pendingCopyR ? (
                            <Loader />
                          ) : (
                            <div>
                              <Button
                                bsSize="large"
                                bsStyle="default"
                                onClick={() => {
                                  this.createDuplicates('company');
                                }}
                                disabled={disableDuplicateForUsersOfCompany}
                              >
                                <i className="fa-fw bg-green fad fa-clone" />
                                {messages.duplicate_campaign}
                              </Button>
                              {typeOfCopyR === 'company' ? (
                                statusCopyR === 'success' ? (
                                  <>
                                    <i className="fas fa-check-circle text-success fa-2x m-l-5" />
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-exclamation-circle text-danger fa-2x m-l-5" />
                                  </>
                                )
                              ) : (
                                <></>
                              )}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Tab.Pane>
                  )}

                  {/* <Tab.Pane eventKey="budget">
                   Budget Component goes here
                 </Tab.Pane>
                 <Tab.Pane eventKey="access">
                   Zugriffsrechte
                 </Tab.Pane> */}
                </Tab.Content>
              </Row>
            </Tab.Container>
          </div>
        </div>
        {action === 'edit' && (
          <div className="right-content">
            <header>
              <h4>{messages.campaign.settings}</h4>
            </header>
            <div className="campaign-actions">
              {/*
             <Button onClick={() => this.addToCart()}>
               {ordering ?
                 <i className="far fa-spin fa-spinner-third"/> : <i className="fas fa-cart-arrow-down bg-green"/>} {messages.order_all}
             </Button>
             */}
              {/* <Button><i className="fas fa-share-alt bg-blue"/>{messages.share}</Button>
               */}
              <Button onClick={() => this.storeCampaign(campaign.id, false)}>
                <i className="fas fa-archive bg-blue" />
                {messages.campaign.archive}
              </Button>
              {/*
              <div className="m-t-40" />
              <SimplePrompt
               buttonLabel={messages.inactive}
               iconClass="fas fa-do-not-enter bg-red"
               onSuccess={e => {
                 this.setInactive(e, campaign.id);
               }}
             /> */}
              <SimplePrompt
                buttonLabel={messages.campaign.delete}
                iconClass="fas fa-trash bg-red"
                onSuccess={e => {
                  deleter(e, campaign.id);
                }}
              />
            </div>
          </div>
        )}
        <footer>
          <Button bsSize="large" bsStyle="default" onClick={this.closeSettings}>
            <i className="fas fa-times bg-red" />
            {messages.campaign.cancel_settings}
          </Button>
          <Button bsSize="large" bsStyle="default" onClick={this.saveSettings} disabled={campaignSavingR}>
            <i className="fa-fw bg-green fal fa-save" />
            {messages.campaign.save_settings}
          </Button>
        </footer>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  /* TODO Actions for add multiple Editions */
  return {
    addToCart: edition => {
      dispatch(cartAddEdition(edition));
    },
    setVariablesAboutListR: data => {
      dispatch(setVariablesAboutListR(data));
    },
    campaignSettingsEditR: (data, datab) => {
      dispatch(campaignSettingsEditR(data, datab));
    },
    campaignSettingsNewR: data => {
      dispatch(campaignSettingsNewR(data));
    },
    duplicateCampaignAndEditionsR: (data, campaignId) => {
      dispatch(duplicateCampaignAndEditionsR(data, campaignId));
    },
  };
};

const mapStateToProps = (state, { campaign }) => {
  return {
    appIntl: state.intl,
    campaignSavingR: state.list.campaigns.campaignSavingR,
    changedR: state.list.campaigns.changedR,
    linkDataR: state.list.campaigns.linkDataR,
    exeThen: state.list.campaigns.exeThen,
    pendingArchive: state.list.campaigns.pendingArchive,
    pendingCopyR: state.campaigns.pendingCopyR,
    statusCopyR: state.campaigns.statusCopyR,
    typeOfCopyR: state.campaigns.typeOfCopyR,
    isCampaignInCart: () => {
      let inCart = 0;
      _forEach(campaign.editions, edition => {
        if (state.cart.items.some(({ edition: { id } }) => id === edition.id)) {
          inCart++;
        }
      });
      return inCart === campaign.editions.length;
    },
    user: state.login.user,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignSettings);
